import React from "react"
import Markdown from "markdown-to-jsx"

interface MarkdownRendererProps {
	markdownContent: string;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({markdownContent}) => {
	return (
		<div className="container my-5">
			<Markdown>{markdownContent}</Markdown>
		</div>
	)
}

export default MarkdownRenderer
